module.exports = __webpack_public_path__ + "img/play_store_en.62f85300.png";